import { MenuItem, TextField, Select, Checkbox } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { valueByName } from './form_utils';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import Tooltip from '@mui/material/Tooltip';
import clsx from 'clsx';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { RegFormType } from '@/api';
import Radio from '@mui/material/Radio';
import Grid from '@mui/material/Grid';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';

const PREFIX = 'ECMultiCheckboxField';

const classes = {
  errorMessage: `${PREFIX}-errorMessage`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.errorMessage}`]: {
    color: 'red',
    paddingTop: 11,
    paddingBottom: 6,
  },
}));

export const ECMultiCheckboxField = props => {
  const { name, options, form, defaultValue, initial, invert, ...rest } = props;

  const fname =
    props.fname ||
    (it => {
      return it.name;
    });
  const fid =
    props.fid ||
    (it => {
      return it.id;
    });

  const [value, setValue] = useState(valueByName(initial, name) || defaultValue || []);

  useEffect(() => {
    form.register(name);
    form.setValue(name, value);
  }, [form, name, value]);

  const handleChange = id => e => {
    if (invert ^ e.target.checked) {
      value.push(id);
    } else {
      const index = value.indexOf(id);
      if (index > -1) {
        value.splice(index, 1);
      }
    }
    form.setValue(name, value);
    setValue(value);
    form.clearErrors(name);
  };

  return (
    <Root>
      {form.formState?.errors?.[name] && (
        <Typography className={classes.errorMessage}>{form.formState.errors[name]?.message}</Typography>
      )}
      {options.map(it => (
        <React.Fragment key={fid(it)}>
          <FormControlLabel
            control={
              <Checkbox checked={!!(invert ^ (value.indexOf(fid(it)) !== -1))} onChange={handleChange(fid(it))} />
            }
            label={fname(it)}
          />
          <br />
        </React.Fragment>
      ))}
    </Root>
  );
};

ECMultiCheckboxField.propTypes = {
  name: PropTypes.string,

  options: PropTypes.array,
  fname: PropTypes.func,
  fid: PropTypes.func,

  form: PropTypes.object,

  defaultValue: PropTypes.any,
  initial: PropTypes.any,
};
